export const mockVaultFolderResponse = {
  status_code: 200,
  msg_code: [
    { code: "VLT_FOLDER_OK", description: "Vault folder view retrieved successfully." }
  ],
  request_id: "mock-request-id",
  body: {
    vault: {
      vault_uuid: "f0c1a0b2-3d45-6789-9abc-def012345678",
      name: "My Workspace",
      description: "User private workspace",
      access_level: "private",
      is_active: true,
      metadata: { region: "us-east-1" },
      created_at: "2025-09-11T12:00:00Z",
      updated_at: "2025-09-12T09:30:00Z",
      status: "active",
      scope: "USER",
      category: "workspace",
      image_url: "https://example.com/image.png",
      vector_store_id: "vec_12345"
    },
    folder: {
      folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee",
      name: "root",
      internal_name: "root",
      path: "/",
      is_active: true,
      created_at: "2025-09-01T10:00:00Z",
      updated_at: "2025-09-10T09:00:00Z",
      parent_folder_uuid: null
    },
    folders: [
      {
        folder_uuid: "11111111-2222-3333-4444-555555555555",
        name: "Technician Reports",
        internal_name: "technician_reports",
        path: "/technician_reports",
        is_active: true,
        created_at: "2025-09-01T10:00:00Z",
        updated_at: "2025-09-10T09:00:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "22222222-3333-4444-5555-666666666666",
        name: "Manufacturer Submissions",
        internal_name: "manufacturer_submissions",
        path: "/manufacturer_submissions",
        is_active: true,
        created_at: "2025-09-01T10:00:00Z",
        updated_at: "2025-09-10T09:00:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "33333333-4444-5555-6666-777777777777",
        name: "Customer Evidence",
        internal_name: "customer_evidence",
        path: "/customer_evidence",
        is_active: true,
        created_at: "2025-09-01T10:00:00Z",
        updated_at: "2025-09-10T09:00:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "44444444-5555-6666-7777-888888888888",
        name: "Warranty Claims",
        internal_name: "warranty_claims",
        path: "/warranty_claims",
        is_active: true,
        created_at: "2025-09-03T08:15:00Z",
        updated_at: "2025-09-11T14:22:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "55555555-6666-7777-8888-999999999999",
        name: "Service Records",
        internal_name: "service_records",
        path: "/service_records",
        is_active: true,
        created_at: "2025-09-04T11:30:00Z",
        updated_at: "2025-09-12T16:45:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "66666666-7777-8888-9999-aaaaaaaaaaaa",
        name: "Quality Assurance",
        internal_name: "quality_assurance",
        path: "/quality_assurance",
        is_active: true,
        created_at: "2025-09-05T09:45:00Z",
        updated_at: "2025-09-13T10:20:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "77777777-8888-9999-aaaa-bbbbbbbbbbbb",
        name: "Training Materials",
        internal_name: "training_materials",
        path: "/training_materials",
        is_active: true,
        created_at: "2025-09-06T13:20:00Z",
        updated_at: "2025-09-14T12:10:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "88888888-9999-aaaa-bbbb-cccccccccccc",
        name: "Compliance Reports",
        internal_name: "compliance_reports",
        path: "/compliance_reports",
        is_active: true,
        created_at: "2025-09-07T15:10:00Z",
        updated_at: "2025-09-15T09:30:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "99999999-aaaa-bbbb-cccc-dddddddddddd",
        name: "Parts Inventory",
        internal_name: "parts_inventory",
        path: "/parts_inventory",
        is_active: true,
        created_at: "2025-09-08T10:25:00Z",
        updated_at: "2025-09-16T14:15:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee",
        name: "Customer Feedback",
        internal_name: "customer_feedback",
        path: "/customer_feedback",
        is_active: true,
        created_at: "2025-09-09T12:40:00Z",
        updated_at: "2025-09-17T16:50:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "bbbbbbbb-cccc-dddd-eeee-ffffffffffff",
        name: "Technical Bulletins",
        internal_name: "technical_bulletins",
        path: "/technical_bulletins",
        is_active: true,
        created_at: "2025-09-10T14:55:00Z",
        updated_at: "2025-09-18T11:35:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "cccccccc-dddd-eeee-ffff-111111111111",
        name: "Financial Reports",
        internal_name: "financial_reports",
        path: "/financial_reports",
        is_active: true,
        created_at: "2025-09-11T16:10:00Z",
        updated_at: "2025-09-19T13:20:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      },
      {
        folder_uuid: "dddddddd-eeee-ffff-1111-222222222222",
        name: "Maintenance Schedules",
        internal_name: "maintenance_schedules",
        path: "/maintenance_schedules",
        is_active: true,
        created_at: "2025-09-12T18:30:00Z",
        updated_at: "2025-09-20T15:45:00Z",
        parent_folder_uuid: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
      }
    ],
    documents: [
      {
        document_uuid: "99999999-aaaa-bbbb-cccc-dddddddddddd",
        name: "OEM Submission – Ford Portal Export – Claim #10231",
        status: "ready",
        created_at: "2025-09-02T12:00:00Z",
        updated_at: "2025-09-10T12:34:56Z",
        description: "Ford warranty claim submission",
        version: 1,
        scope: "USER",
        summary: "Warranty claim documentation for Ford vehicle repairs",
        path: "/manufacturer_submissions",
        owner_uuid: "7e6bd6d0-1e6b-4b3e-9a51-1234567890ab",
        owner_full_name: "Jane Doe"
      },
      {
        document_uuid: "88888888-bbbb-cccc-dddd-eeeeeeeeeeee",
        name: "OEM Submission – Toyota Portal Export – Claim #10232",
        status: "ready",
        created_at: "2025-09-02T12:00:00Z",
        updated_at: "2025-09-10T12:34:56Z",
        description: "Toyota warranty claim submission",
        version: 1,
        scope: "USER",
        summary: "Warranty claim documentation for Toyota vehicle repairs",
        path: "/manufacturer_submissions",
        owner_uuid: "7e6bd6d0-1e6b-4b3e-9a51-1234567890ab",
        owner_full_name: "Jane Doe"
      },
      {
        document_uuid: "77777777-cccc-dddd-eeee-ffffffffffff",
        name: "Honda Warranty Claim – Engine Repair Documentation",
        status: "pending",
        created_at: "2025-09-03T14:30:00Z",
        updated_at: "2025-09-11T16:45:00Z",
        description: "Honda engine repair warranty claim with detailed diagnostics",
        version: 2,
        scope: "USER",
        summary: "Complete documentation of Honda engine repair process and warranty claim",
        path: "/warranty_claims",
        owner_uuid: "8f7ce7e1-2f7c-5c4f-0b62-2345678901bc",
        owner_full_name: "John Smith"
      },
      {
        document_uuid: "66666666-dddd-eeee-ffff-111111111111",
        name: "BMW Service Record – Transmission Overhaul",
        status: "completed",
        created_at: "2025-09-04T09:15:00Z",
        updated_at: "2025-09-12T11:20:00Z",
        description: "BMW transmission overhaul service record with parts list",
        version: 1,
        scope: "USER",
        summary: "Detailed service record for BMW transmission overhaul including all parts and labor",
        path: "/service_records",
        owner_uuid: "9g8df8f2-3g8d-6d5g-1c73-3456789012cd",
        owner_full_name: "Sarah Johnson"
      },
      {
        document_uuid: "55555555-eeee-ffff-1111-222222222222",
        name: "Mercedes Quality Inspection Report",
        status: "ready",
        created_at: "2025-09-05T11:45:00Z",
        updated_at: "2025-09-13T13:30:00Z",
        description: "Mercedes vehicle quality inspection report with findings",
        version: 3,
        scope: "USER",
        summary: "Comprehensive quality inspection report for Mercedes vehicle with recommendations",
        path: "/quality_assurance",
        owner_uuid: "0h9eg9g3-4h9e-7e6h-2d84-4567890123de",
        owner_full_name: "Mike Wilson"
      },
      {
        document_uuid: "44444444-ffff-1111-2222-333333333333",
        name: "Audi Training Manual – Electrical Systems",
        status: "draft",
        created_at: "2025-09-06T16:20:00Z",
        updated_at: "2025-09-14T15:10:00Z",
        description: "Audi electrical systems training manual for technicians",
        version: 1,
        scope: "USER",
        summary: "Comprehensive training manual for Audi electrical systems maintenance",
        path: "/training_materials",
        owner_uuid: "1i0fh0h4-5i0f-8f7i-3e95-5678901234ef",
        owner_full_name: "Lisa Brown"
      },
      {
        document_uuid: "33333333-1111-2222-3333-444444444444",
        name: "Volkswagen Compliance Report – Safety Standards",
        status: "ready",
        created_at: "2025-09-07T08:30:00Z",
        updated_at: "2025-09-15T10:45:00Z",
        description: "Volkswagen safety standards compliance report",
        version: 2,
        scope: "USER",
        summary: "Detailed compliance report for Volkswagen safety standards and regulations",
        path: "/compliance_reports",
        owner_uuid: "2j1gi1i5-6j1g-9g8j-4f06-6789012345fg",
        owner_full_name: "David Miller"
      },
      {
        document_uuid: "22222222-2222-3333-4444-555555555555",
        name: "Nissan Parts Inventory – Engine Components",
        status: "ready",
        created_at: "2025-09-08T13:45:00Z",
        updated_at: "2025-09-16T17:30:00Z",
        description: "Nissan engine components inventory tracking document",
        version: 1,
        scope: "USER",
        summary: "Complete inventory of Nissan engine components with stock levels and suppliers",
        path: "/parts_inventory",
        owner_uuid: "3k2hj2j6-7k2h-0h9k-5g17-7890123456gh",
        owner_full_name: "Emily Davis"
      },
      {
        document_uuid: "11111111-3333-4444-5555-666666666666",
        name: "Hyundai Customer Satisfaction Survey Results",
        status: "completed",
        created_at: "2025-09-09T15:20:00Z",
        updated_at: "2025-09-17T19:15:00Z",
        description: "Hyundai customer satisfaction survey analysis and results",
        version: 4,
        scope: "USER",
        summary: "Comprehensive analysis of Hyundai customer satisfaction survey with recommendations",
        path: "/customer_feedback",
        owner_uuid: "4l3ik3k7-8l3i-1i0l-6h28-8901234567hi",
        owner_full_name: "Robert Garcia"
      },
      {
        document_uuid: "00000000-4444-5555-6666-777777777777",
        name: "Mazda Technical Bulletin – Hybrid System Updates",
        status: "draft",
        created_at: "2025-09-10T17:35:00Z",
        updated_at: "2025-09-18T21:00:00Z",
        description: "Mazda hybrid system technical updates and maintenance procedures",
        version: 1,
        scope: "USER",
        summary: "Technical bulletin covering Mazda hybrid system updates and maintenance procedures",
        path: "/technical_bulletins",
        owner_uuid: "5m4jl4l8-9m4j-2j1m-7i39-9012345678ij",
        owner_full_name: "Jennifer Martinez"
      },
      {
        document_uuid: "ffffffff-5555-6666-7777-888888888888",
        name: "Subaru Financial Analysis – Q3 2025",
        status: "ready",
        created_at: "2025-09-11T19:50:00Z",
        updated_at: "2025-09-19T22:25:00Z",
        description: "Subaru financial performance analysis for Q3 2025",
        version: 2,
        scope: "USER",
        summary: "Detailed financial analysis of Subaru performance for Q3 2025 with projections",
        path: "/financial_reports",
        owner_uuid: "6n5km5m9-0n5k-3k2n-8j40-0123456789jk",
        owner_full_name: "Christopher Lee"
      },
      {
        document_uuid: "eeeeeeee-6666-7777-8888-999999999999",
        name: "Kia Maintenance Schedule – 2025 Model Year",
        status: "pending",
        created_at: "2025-09-12T21:05:00Z",
        updated_at: "2025-09-20T23:40:00Z",
        description: "Kia maintenance schedule for all 2025 model year vehicles",
        version: 3,
        scope: "USER",
        summary: "Comprehensive maintenance schedule for Kia 2025 model year vehicles with intervals",
        path: "/maintenance_schedules",
        owner_uuid: "7o6ln6n0-1o6l-4l3o-9k51-1234567890kl",
        owner_full_name: "Amanda Rodriguez"
      }
    ],
    folder_count: 13,
    document_count: 12
  },
  meta: {
    folders: { total: 13, limit: 20, offset: 0, next_cursor: null },
    documents: { total: 12, limit: 20, offset: 0, next_cursor: null }
  }
};
